import { FC } from 'react';
import { Typography } from '@mui/material';

import { formatPriceFromCents } from '@mopla/utils';

import { MplChip } from '../../atoms/MplChip';

import { VoucherChipRow } from './styled';

interface IBookingVoucherValidChipProps {
	voucherCode: string;
	/** Discount value in cents (will be shown as negative) */
	discountValue: number;
	/** Omit to render a read-only chip without a delete/cross button. */
	onDelete?: () => void;
}

export const BookingVoucherValidChip: FC<IBookingVoucherValidChipProps> = ({
	voucherCode,
	discountValue,
	onDelete,
}) => {
	return (
		<VoucherChipRow>
			<MplChip
				label={voucherCode}
				elevated
				onDelete={onDelete}
				deleteTestId="bookingVoucher-delete-button"
				dataTestId="bookingVoucher-validCode-chip"
			/>
			<Typography variant="b2">
				{formatPriceFromCents(discountValue)}
			</Typography>
		</VoucherChipRow>
	);
};
